import { render, staticRenderFns } from "./LimitMan.vue?vue&type=template&id=4c5b7ac1&scoped=true"
import script from "./LimitMan.vue?vue&type=script&lang=js"
export * from "./LimitMan.vue?vue&type=script&lang=js"
import style0 from "./LimitMan.vue?vue&type=style&index=0&id=4c5b7ac1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b7ac1",
  null
  
)

export default component.exports